import { render, staticRenderFns } from "./Indice.vue?vue&type=template&id=27c66e95&"
import script from "./Indice.vue?vue&type=script&lang=js&"
export * from "./Indice.vue?vue&type=script&lang=js&"
import style0 from "./Indice.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports